import BaseService from '@/services/base_service';
import { clearPhone } from '@/services/string';
import Axios from 'axios';

export default class PostService extends BaseService {

  async list(params) {
    try {
      return await axios.get('/post', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id) {
    try {
      return await axios.get('/post/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model) {
    try {
      return await axios.post('post/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async saveImage(model) {
    try {
      return await axios.post('post/imagem', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/post/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    console.log("envia para od elete");
    try {
      return await axios.delete('/post/' + id);
    } catch (e) {
      throw e;
    }
  }


}



// WEBPACK FOOTER //
// ./src/services/post.js